import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { UpdateCsvExcelTradesAdditionsRequestModel, UpdateCsvExcelTradesAdditionsResponseModel } from "@/features/accounts/csv-excel/services/update-trades-additions-model";

export class UpdateCsvExcelTradesAdditionsApi {
  /**
   * CSV/Excel明細メモ・無効明細更新API
   */
  public updateCsvExcelTradesAdditions = async (
    param: UpdateCsvExcelTradesAdditionsRequestModel
  ): Promise<UpdateCsvExcelTradesAdditionsResponseModel> => {
    const path = `/api/csvexcelaccounts/tradesadditions`;
    const res = await ApiClient.instance.put<UpdateCsvExcelTradesAdditionsResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
